<div class="sso-container">
  <p *ngIf="messageKey">{{ messageKey | translate }}</p>
  <a *ngIf="portalUrl" [href]="portalUrl">{{ 'sso_back_to_portal' | translate }}</a>
  <a *ngIf="messageKey" routerLink="/login">{{ 'sso_back_to_login' | translate }}</a>
</div>
